import typography from './typography';
import colors from './colors';

const theme = { typography, colors };

export default theme;
